import type { SourceId } from '../types.ts';

// Map a chunk/claim's `channel_name` to the SourceId used by CITATION_SOURCES.
// Without this, both VideoMomentsCard and AssistantBlockRenderer's claim case
// were hardcoding source='cybertron-vgc' for EVERY chunk, surfacing "retrieved
// · Cybertron VGC" even on top of a Viera (JP) quote. Centralised here so
// adding a new creator only needs one edit.
//
// Match channel-name fragments rather than exact strings — YouTube channel
// names sometimes drift (suffixes, formatting). The JP channels use their
// kanji handles in our DB ("ビエラ/ポケモン世界優勝", "UMA【キヌガワ】") so we
// match either kanji or romanised forms defensively.
export function sourceForChannel(channelName: string | null | undefined): SourceId {
  const lower = (channelName ?? '').toLowerCase();
  if (lower.includes('wolfey')) return 'wolfey-vgc';
  if (lower.includes('cybertron')) return 'cybertron-vgc';
  if (lower.includes('yoshi')) return 'yoshi37-vgc';
  if (lower.includes('joeux')) return 'joeux9-vgc';
  if (channelName?.includes('ビエラ') || lower.includes('viera')) return 'viera-jp';
  if (
    channelName?.includes('キヌガワ') ||
    lower.includes('kinugawa') ||
    lower.includes('uma')
  )
    return 'kinugawa-jp';
  // Fallback to cybertron-vgc keeps the legacy attribution colour but is now
  // only used when we genuinely don't recognise the channel — log-worthy if
  // it ever fires for a known creator.
  return 'cybertron-vgc';
}
